const subheadingsData = {
    1: [
        {
            title: "About Me",
            content: (
                <>
                    <p>
                        Hi, my name is Jin and I'm a software developer based in Vancouver, BC, Canada. I'm passionate about beautiful interfaces, intuitive UX, and smart, scalable products.
                    </p>
                    <p>
                        I also love hockey, food, the rain, and making music.
                    </p>
                </>
            )
        }
    ],
    2: [
        {
            title: "University of British Columbia",
            content: (
                <>
                    <p>
                        Bachelor of Science -<br></br> Computer Science Major
                    </p>
                    <p>
                        Graduated in May of 2023
                    </p>
                    <p>
                        I spent my first three years of university in Microbiology until I found my true passion in Software Development, made the leap, and never looked back.
                    </p>
                </>
            )
        }
    ],
    3: [
        {
            title: "Amazon - SDE Intern",
            content: (
                <>
                    <p>
                        May 2022 ~ Aug 2022
                    </p>
                    <p>
                    • Designed, implemented, tested, and deployed a full-stack project which provides visibility into planning entities and
saves Amazon thousands of dollars each month in working-hours. Fully documented
                    </p>
                    <p>
                    • Intuitive single-page web app using TypeScript, React, Amazon Katal, S3, Cloudfront to use a serverless
architecture, caching data on user edge servers, resulting in 23% faster load and cache times and better scalability
than initial proposed server design. Tested with React testing library, Jest, and Enzyme 
                    </p>
                    <p>
                    • Back end infrastructure also using serverless architecture using DynamoDB, Amazon Honeycomb and Java to
implement file ingestion, event ingestion, and querying with RESTful API integration for the front end with
average 58ms API response time on queries.

                    </p>
                </>
            )
        },
        {
            title: "Immersio - Mobile Developer Intern",
            content: (
                <>
                    <p>
                        May 2021 ~ Aug 2021
                    </p>
                    <p>
                    • As the sole developer on the team at the start of the product’s development - transformed Figma mockups and the
managers’ vision into a polished, modern app - keeping in mind scalability and providing my opinions as a
developer to the team, and published a beta version onto the App Store, with full set of documentation
                    </p>
                    <p>
                    • Front end development in React Native and JavaScript, designing custom components with React Hooks, with
focus on custom components to minimize excess packages reducing app size by 12% and increasing reusability.
                    </p>
                    <p>
                    • Back end development in JavaScript and PostgreSQL, designing efficient relational databases
(19% reduction in database size with new design), connecting user progress and lesson content to databases,
integrating social media for better user experience, and designing RESTful API’s for seamless and intuitive lesson
plans for users
                    </p>
                </>
            )
        },
        {
            title: "Perk Hero - Software Developer Intern",
            content: (
                <>
                    <p>
                        Sept 2020 ~ Apr 2021
                    </p>
                    <p>
                    • Created & followed structured test plans and test cases to validate operation for new features & changes,
documented test coverage, bugs, and risks to development team, finding an average of 4.3 bugs per version release
                    </p>
                    <p>
                    • Front end development in React Native, React, and JavaScript. Increased merchant satisfaction by 33% with my
new design for merchant onboarding
                    </p>
                    <p>
                    • Back end development in JavaScript, Spring and PHP designing and implementing RESTful API’s
reducing data transfer times by 12%
                    </p>
                    <p>
                    • Work with AWS and Azure: mainly DynamoDB and CosmosDB to store and backup user data, update app content
for customers, and test various features in staging environment

                    </p>
                </>
            )
        }
    ]
};

export default subheadingsData;